import { useApi } from "#hooks/useApi"
import { DialogExit } from "#savings-fund/components/dialog/DialogExit"
import Formulario from "#savings-fund/components/Formulario"
import TableColaborador from "#savings-fund/components/Table/TableColaborador"
import { REQUEST_DISABLE_DATE } from "#savings-fund/constants"
import { SavingsFundProvider } from "#savings-fund/contexts/contexts"
import { savingsFundGet } from "#savings-fund/services/Api"
import { Box, Button, Paper, Skeleton, Stack, Typography } from "@mui/material"
import { Fragment, useMemo, useState } from "react"

export default function SavingsFundColaborador({ colaborador }) {
	const [reload, setReload] = useState(false)
	const params = useMemo(() => ({ colaborador }), [colaborador])
	const { loading, data, error } = useApi(savingsFundGet, {
		autoFetch: true,
		params,
		reload,
	})
	const { solicitudes = [] } = data || {}

	if (loading) return <Skeleton variant="rectangular" height={"45vh"} />
	if (error)
		return (
			<Box component={Paper} sx={{ p: 2 }}>
				<Typography>Ha ocurrido un error</Typography>
				<Typography>{error}</Typography>
			</Box>
		)
	return (
		<SavingsFundProvider {...{ reload, setReload, colaborador }}>
			<Box component={Paper} sx={{ p: 2 }}>
				<Stack
					spacing={2}
					direction={"column"}
					alignContent={"center"}
					alignItems={"center"}
					justifyContent={"center"}
					width={"90vw"}
				>
					<Typography variant="h4">Solicitudes Caja Ahorro</Typography>
					<SavingsButtons savingData={data} />
					<TableColaborador data={solicitudes} />
				</Stack>
			</Box>
		</SavingsFundProvider>
	)
}

const SavingsButtons = ({ savingData }) => {
	const { can_request, in_progress, is_active } = savingData || {}
	const [open, setOpen] = useState(false)
	const fecha = new Date()
	if (
		REQUEST_DISABLE_DATE.month === fecha.getMonth() + 1 &&
		REQUEST_DISABLE_DATE.day <= fecha.getDate()
	)
		return <Typography>Caja de ahorro no disponible en este momento </Typography>

	if (is_active) return <ButtonExit />

	if (in_progress) return <Typography>Solicitud en progreso</Typography>

	if (!can_request)
		return <Typography>No se pueden solicitar ingreso en este periodo </Typography>

	return (
		<Fragment>
			<Button onClick={() => setOpen(true)}>Solicitar Caja Ahorro</Button>
			<Formulario {...{ open, setOpen }} />
		</Fragment>
	)
}

const ButtonExit = () => {
	const [open, setOpen] = useState(false)

	return (
		<Fragment>
			<Button onClick={() => setOpen(true)}>Salir Caja Ahorro</Button>
			<DialogExit {...{ open, setOpen }} />
		</Fragment>
	)
}
